module.exports = __webpack_public_path__ + "img/image3@3x.749a2374.png";